const routes = {
    main: "/",
    home: "/home",

    // Auth
    login: "/login",
    register: "/register",
    verifyEmail: "/verify-email",
    forgotPassword: "/forgot-password",
    changePassword: "/change-password",

    // Marketplace
    products: "/products",
    productDetail: "/products/:slug",
    categories: "/categories",
    cart: "/cart",
    checkout: "/checkout",
    orderSuccess: "/order-success",
    
    // User
    profile: "/profile",
    orders: "/orders",
    
    // Admin
    admin: "/admin",
    adminCategories: "/admin/categories",
    adminProducts: "/admin/products",
    adminOrders: "/admin/orders",
    adminMaterials: "/admin/materials",
    adminColors: "/admin/colors",
    adminSizes: "/admin/sizes",
    adminCustomizations: "/admin/customizations",
    
    // Other
    contact: "/contact",
    notFound: "*",
};

export default routes;